import * as React from 'react';
import { createContext, useContext, useState } from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export type FrontPageRedesignQ32025ContextType = {
  enableFrontPageRedesignHeroCTAOptimization?: boolean;
  enableSelfServeFrontPageRedesign: boolean;
};

const FrontPageRedesignQ32025Context = createContext<FrontPageRedesignQ32025ContextType>({
  enableFrontPageRedesignHeroCTAOptimization: false,
  enableSelfServeFrontPageRedesign: false,
});

const FrontPageRedesignQ32025Provider = ({ children }: React.PropsWithChildren) => {
  const [enableFrontPageRedesignHeroCTAOptimization] = useState(
    GrowthDiscoveryEpicClient.get('enableLOHPRedesignHeroCTAOptimization')
  );
  const [enableSelfServeFrontPageRedesign] = useState(
    GrowthDiscoveryEpicClient.get('enableSelfServeFrontPageRedesign')
  );

  return (
    <FrontPageRedesignQ32025Context.Provider
      value={{
        enableFrontPageRedesignHeroCTAOptimization,
        enableSelfServeFrontPageRedesign,
      }}
    >
      {children}
    </FrontPageRedesignQ32025Context.Provider>
  );
};

export const useFrontPageRedesignQ32025Data = () => {
  return useContext(FrontPageRedesignQ32025Context);
};

export default FrontPageRedesignQ32025Provider;
